import { Role } from '../enums';

export interface UserCreateUpdateRequest {
  firstName: string;
  lastName: string;
  email?: string;
  role?: Role;
  customerId?: number;
  partnerId?: string;
  note?: string;
}

export namespace UserCreateUpdateRequest {
  export function mapToApiValue(request: UserCreateUpdateRequest): any {
    return {
      firstName: request.firstName,
      lastName: request.lastName,
      email: request.email,
      role: request.role !== undefined ? Role.mapToApiValue(request.role) : null,
      customerId: request.customerId,
      partnerId: request.partnerId,
      note: request.note,
    };
  }
}
